/**
 * --------------------------------------------
 * KANYOS TemplateWidget.js
 * License ANZAS
 * --------------------------------------------
 */

import $ from 'jquery'

/**
 * Constants
 * ====================================================
 */

const NAME = 'TemplateWidget'
const DATA_KEY = 'lte.templatewidget'
// const EVENT_KEY = `.${DATA_KEY}`
const JQUERY_NO_CONFLICT = $.fn[NAME]

// const EVENT_CHANGED = `changed${EVENT_KEY}`

// const SELECTOR_DATA_TOGGLE = '[data-widget="dropdown-list"]'

const Default = {
  dataSource: undefined,
  containerSelector: undefined
}

/**
 * Class Definition
 * ====================================================
 */

class TemplateWidget {
  constructor(element, config) {
    this._config = config
    this._element = element

    this._init()
  }

  // Private

  _init() {
    if (this._config.dataSource === undefined ||
      this._config.containerSelector === undefined) {
      return
    }

    this._element.find(this._config.containerSelector).html(this._config.dataSource)
  }

  // Static

  static _jQueryInterface(config) {
    return this.each(function () {
      let data = $(this).data(DATA_KEY)

      if (!data) {
        data = $(this).data()
      }

      const _options = $.extend({}, Default, typeof config === 'object' ? config : data)
      const plugin = new TemplateWidget($(this), _options)

      $(this).data(DATA_KEY, typeof config === 'object' ? config : data)

      if (config === 'init') {
        plugin[config]()
      }
    })
  }
}

/**
 * Data API
 * ====================================================
 */

// $(window).on('load', () => {
//   TemplateWidget._jQueryInterface.call($(SELECTOR_DATA_TOGGLE))
// })

/**
 * jQuery API
 * ====================================================
 */

$.fn[NAME] = TemplateWidget._jQueryInterface
$.fn[NAME].Constructor = TemplateWidget
$.fn[NAME].noConflict = function () {
  $.fn[NAME] = JQUERY_NO_CONFLICT
  return TemplateWidget._jQueryInterface
}

export default TemplateWidget
